import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import PageV2 from "components/shared/PageV2";
import { useSearchParams } from "react-router-dom";
import CategoryTagsView from "./CategoryTagsView";
import { FETCH_TAG_CATEGORIES } from "./graphql";

const TagCategoriesPage = () => {
  const { loading, error, data } = useQuery(FETCH_TAG_CATEGORIES);
  const [searchParams, setSearchParams] = useSearchParams({
    q: "",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const params = Object.fromEntries(searchParams.entries());
  const q = params.q || "";

  const categories = data.taggingCategories;

  return (
    <PageV2
      index
      title="Tags"
      toolbar={
        <div>
          <a
            href={
              process.env.REACT_APP_SERVER_ADMIN_URL + "tagging/tagcategory"
            }
            target="_blank"
          >
            Manage Categories
          </a>
        </div>
      }
    >
      <div className="flex items-center space-x-4">
        <div className="flex-1">
          <SearchBar
            placeholder="Search tags..."
            value={q}
            onChange={(value) => setSearchParams({ ...params, q: value })}
          />
        </div>
      </div>

      <div className="card py-1 p-0 flex-1 overflow-auto">
        <table className="with-line">
          <tbody>
            {categories.map((i) => (
              <tr key={i.id}>
                <td className="px-4">
                  <div>
                    #{i.id}. <b>{i.name}</b>
                  </div>
                  {i.description && (
                    <div className="text-gray-500">{i.description}</div>
                  )}
                </td>
                <td>
                  <CategoryTagsView category={i} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </PageV2>
  );
};

export default TagCategoriesPage;
